import MMapRoute from './components/MMapRoute';

import './components/o-route';

const element = document.querySelector('.o-routes__map');
if (element) {
  window.mMapRoute = new MMapRoute(element);
} else {
  const elements = document.querySelectorAll('.o-route__map');
  elements.forEach((_) => new MMapRoute(_));
}
